<template>
  <login-page>
    <login-card></login-card>
  </login-page>
</template>

<script lang="ts">
import Vue from "vue";
import LoginCard from "@/components/auth/LoginCard.vue";
import LoginPage from "./LoginPage.vue";

import { createHelpers } from "vuex-typescript-interface";
import { RootStoreInterface } from "@/store/types";

const { mapGetters } = createHelpers<RootStoreInterface>();

const getters = mapGetters(["isLoggedIn"]);

export default Vue.extend({
  components: { LoginCard, LoginPage },
  computed: {
    ...getters
  }
});
</script>
